export const UPDATE_FAQBUILDER_STATE = "UPDATE_FAQBUILDER_STATE"
export const FAQ_MORE_FAQS_LOADED = "FAQ_MORE_FAQS_LOADED"
export const FAQ_UPDATED = "FAQ_UPDATED"
export const ADD_NEW_FAQ = "ADD_NEW_FAQ"